<template>
  <div id="admin-question-edit">
    <!-- 编辑题库 -->
    <div class="content" v-loading="loading">
      <div class="goback" @click="goback">
        <i class="el-icon-d-arrow-left"></i>返回
      </div>
      <div class="line">
        <div class="title">科目:</div>
        <div class="value">
          <div class="tip_select">
            <el-select v-model="data.subject" placeholder="请选择科目">
              <el-option
                v-for="item in subjectOptions"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </div>
        </div>
      </div>
      <div class="line">
        <div class="title">评分标准:</div>
        <div class="value">
          <el-radio-group v-model="data.scaleMarks">
            <el-radio :label="'0'">机器判定</el-radio>
            <!-- <el-radio :label="'1'">人工判定</el-radio> -->
          </el-radio-group>
          <div class="tips">
            机器判定的评分标准将严格按照系统设定的答案进行!
          </div>
        </div>
      </div>
      <!-- <div class="line">
        <div class="title">题库类型:</div>
        <div class="value">
          <el-radio-group v-model="data.questionType">
            <el-radio
              :label="item.value"
              v-for="(item, index) in questionTypeOptions"
              :key="index"
              >{{ item.label }}</el-radio
            >
          </el-radio-group>
        </div>
      </div> -->
      <div class="line">
        <div class="title">题目类型:</div>
        <div class="value">
          <el-radio-group
            v-model="data.topicnType"
            @change="changeQuestionType"
            :disabled="data.id != ''"
          >
            <el-radio
              :label="item.value"
              v-for="(item, index) in topicnTypeOptions"
              :key="index"
              >{{ item.label }}</el-radio
            >
          </el-radio-group>
        </div>
      </div>
      <div class="line">
        <div class="title">题干:</div>
        <div
          class="value ueditor"
          v-html="data.questionStem"
          @click="editQuestionStem('编辑题干', data.questionStem, -1)"
        ></div>
      </div>
      <div class="line" v-if="data.topicnType == '0' || data.topicnType == '1'">
        <div class="title">选项:</div>
        <div class="value bj">
          <div
            class="li"
            v-for="(item, index) in data.questionOptions"
            :key="index"
          >
            <div class="title">{{ item.title }}:</div>
            <div
              class="li-va ueditor"
              v-html="item.value"
              @click="editQuestionStem('编辑选项', item.value, index)"
            ></div>
            <div class="add_but" @click="removeQuestionOptions(index)">
              <i class="el-icon-minus"></i>移除选项
            </div>
          </div>
          <div class="add_but" @click="addQuestionOptions">
            <i class="el-icon-plus"></i>添加选项
          </div>
        </div>
      </div>
      <div class="line">
        <div class="title">答案:</div>
        <div
          class="value bj"
          v-if="data.topicnType == '0' || data.topicnType == '1'"
        >
          <!-- 选择题答案 -->
          <div
            class="li"
            v-for="(item, index) in data.questionAnswer"
            :key="index"
          >
            <!-- <div class="title" v-if="item.title != ''">{{ item.title }}:</div> -->
            <div class="li-va">
              <el-select
                v-model="item.value"
                placeholder="请选择"
                :multiple="data.topicnType == '1'"
              >
                <el-option
                  v-for="(it, ii) in data.questionOptions"
                  :key="ii"
                  :label="it.title"
                  :value="it.title"
                >
                </el-option>
              </el-select>
            </div>
          </div>
        </div>
        <div class="value bj" v-else-if="data.topicnType == '2'">
          <!-- 填空题答案 -->
          <div
            class="li"
            v-for="(item, index) in data.questionAnswer"
            :key="index"
          >
            <div class="title">{{ item.title }}:</div>
            <div
              class="li-va ueditor"
              v-html="item.value"
              @click="editQuestionStem('填空题答案', item.value, index)"
            ></div>
          </div>
        </div>
        <div class="value" v-else-if="data.topicnType == '3'">
          <!-- 判断题答案 -->
          <el-radio-group v-model="data.questionAnswer">
            <el-radio :label="'0'">
              <i class="el-icon-check"></i>
            </el-radio>
            <el-radio :label="'1'">
              <i class="el-icon-close"></i>
            </el-radio>
          </el-radio-group>
        </div>
        <div
          class="value ueditor"
          v-else
          v-html="data.questionAnswer[0].value"
          @click="
            editQuestionStem('简答题答案', data.questionAnswer[0].value, -1)
          "
        ></div>
      </div>
      <div class="line">
        <div class="title">知识点:</div>
        <div class="value">
          <el-input
            type="textarea"
            :rows="2"
            placeholder="请输入相关知识点"
            v-model="data.knowledgePoint"
            clearable
          >
          </el-input>
        </div>
      </div>
      <div class="line">
        <div class="title">难度:</div>
        <div class="value">
          <div class="div-flex-center" style="height: 35px">
            <i
              :class="{
                'el-icon-star-off': true,
                'el-icon-star-on': data.gradeOfDifficulty >= s,
              }"
              v-for="s in 5"
              :key="s"
              @click="data.gradeOfDifficulty = s"
            ></i>
          </div>
        </div>
      </div>
      <div class="line">
        <div class="title"></div>
        <div class="add_but" @click="submit">
          <i class="el-icon-check"></i> 提交
        </div>
      </div>
    </div>

    <ueditor_dialog
      v-if="ueditorDialogData.flag"
      :title="ueditorDialogData.title"
      :content="ueditorDialogData.content"
      @cancelDialog="cancelDialog"
      @makeSure="makeSure"
    ></ueditor_dialog>
  </div>
</template>

<script>
import * as questionData from "../js/question.js";
export default {
  data() {
    return {
      loading: false,
      userData: {
        // 当前登录用户基本信息
        id: "",
      },
      data: {
        id: "",
        subject: "", // 科目
        scaleMarks: "0", // 评分标准
        topicnType: "0", // 题目类型
        questionType: "2", // 题库类型
        questionStem: "", // 题干  含html
        questionStemText: "", // 题干  纯文本
        questionOptions: [], // 单选和多选的选项组
        questionAnswer: [], // 答案
        knowledgePoint: "", // 相关知识点
        gradeOfDifficulty: 3, // 难度
      },
      id: "", // 当前编辑的题库ID  新增时为空

      // subject: [], // 科目
      subjectOptions: [
        // 接口获取
        { id: "111", name: "计算机基础" },
        { id: "122", name: "JAVA高级编程" },
      ],
      tempSubject: {},
      // scaleMarks: "0", // 评分标准
      // topicnType: "0", // 题目类型
      topicnTypeOptions: questionData.getOptions("topic"),
      // questionType: "0", // 题库类型
      questionTypeOptions: questionData.getOptions("question"),
      // questionStem: "", // 题干
      ueditorDialogData: {
        title: "",
        flag: false,
        content: "",
      },
      tempQuestionOptionIndex: -1, // 暂存当前编辑的选项索引
      // questionOptions: [], // 单选和多选的选项组
      // questionAnswer: [], // 答案
      // knowledgePoint: "", // 相关知识点
      // gradeOfDifficulty: 1, // 难度
    };
  },
  methods: {
    /**
     * 初始化界面
     */
    async init() {
      // 1.获取基本属性值  如所有科目列表
      await this.getAllSubjectForSelect();
      // 2.获取当前题库的基本信息  id为空时忽略此步骤
      // 3.关闭加载项
      // this.getQuestionBankDetailsById();
    },
    /**
     * 查看所有科目--下拉框专用
     */
    async getAllSubjectForSelect() {
      try {
        let resultData = await this.$request({
          url: "/subjects/getAllSubjectForSelect",
          method: "post",
          data: null,
        });
        this.subjectOptions = resultData;
        if (this.id != "") {
          await this.getQuestionBankDetailsById();
        }
      } catch (error) {
        this.$message.error(error.message);
      }
    },
    /**
     * 获取题库的具体题目信息
     */
    async getQuestionBankDetailsById() {
      try {
        if (this.id != "") {
          let requestData = {
            id: this.id,
          };
          let resultData = await this.$request({
            url: "/questionBank/getQuestionBankDetailsById",
            method: "post",
            data: requestData,
          });
          this.data = JSON.parse(JSON.stringify(resultData));
          let tempAnswer = [];
          switch (resultData.topicnType) {
            case "0":
            // 单选
            case "2":
            // 填空
            case "4":
              // 简答
              tempAnswer = resultData.questionAnswer;
              break;
            case "1":
              // 多选
              let dd = [];
              resultData.questionAnswer.forEach((element) => {
                dd.push(element.value);
              });
              tempAnswer = [{ value: dd }];
              break;
            case "3":
              // 判断
              tempAnswer =
                resultData.questionAnswer.length > 0
                  ? resultData.questionAnswer[0].value
                  : "";
              break;

            default:
              break;
          }
          // if (resultData.topicnType == "3") {
          //   // 填空  将答案从数组中拿出来
          //   this.data.questionAnswer =
          //     resultData.questionAnswer.length > 0
          //       ? resultData.questionAnswer[0]
          //       : "";
          // }
          // if (resultData.topicnType == "4") {
          //   // 简答题  将答案从数组中拿出来
          //   this.data.questionAnswer =
          //     resultData.questionAnswer.length > 0
          //       ? resultData.questionAnswer[0].value
          //       : "";
          // }
          this.data.questionAnswer = tempAnswer;
          this.$set(this.data, "id", requestData.id);
          console.log(this.data);
          this.loading = false;
        }
      } catch (error) {
        this.$message.error(error.message);
        this.loading = false;
      }
    },
    /**
     * 添加标签
     * 注意去重
     */
    addSubject(value) {
      let data = this.data.subject;
      data.push(JSON.parse(JSON.stringify(value)));
      let set = new Set(data.map(JSON.stringify));
      this.data.subject = Array.from(set).map(JSON.parse);
      this.tempSubject = {};
    },
    /**
     * 删除标签
     */
    deleteSubject(index) {
      this.data.subject.splice(index, 1);
    },
    /**
     * 题目类型的切换
     */
    changeQuestionType(val) {
      console.log("aaaaaaaaaaaaa");
      this.data.questionStem = "";
      switch (this.data.topicnType) {
        case "0":
          // 单选题
          this.data.questionOptions = [];
          this.data.questionAnswer = [];
          break;
        case "1":
          // 多选题
          this.data.questionOptions = [];
          this.data.questionAnswer = [];
          break;
        case "2":
          // 填空题
          this.data.questionAnswer = [];
          break;
        case "3":
          // 判断题
          this.data.questionAnswer = "0";
          break;
        case "4":
          // 简答题
          this.data.questionAnswer = [{ value: "" }];
          break;

        default:
          break;
      }
      console.log(val, this.data);
    },
    /**
     * 编辑题干
     */
    editQuestionStem(title, content, index) {
      this.tempQuestionOptionIndex = index;
      this.ueditorDialogData.title = title;
      this.ueditorDialogData.content = content;
      this.ueditorDialogData.flag = true;
    },
    /**
     * 确认编辑框内容
     */
    makeSure(content) {
      console.log("编辑器返回的值", content);
      let data = questionData.questionItemReset(content.content);
      let text = questionData.questionItemReset(content.text);
      if (this.ueditorDialogData.title == "编辑题干") {
        if (this.data.topicnType == "2") {
          // 填空题
          if (data.length == 0) {
            this.$message.error("请插入填空");
            return;
          }
          this.data.questionAnswer = data;
        }
        if (this.data.topicnType == "0" || this.data.topicnType == "1") {
          // 选择题
          this.data.questionAnswer =
            data.length == 0
              ? [
                  {
                    id: null,
                    itemUuid: "",
                    title: "",
                    value: "",
                  },
                ]
              : data;
          this.data.questionAnswer.forEach((element) => {
            element.value = this.data.topicnType == "0" ? "" : [];
          });
        }
        this.data.questionStem = content.content;
        this.data.questionStemText = content.text;
      } else if (this.ueditorDialogData.title == "编辑选项") {
        // 编辑选项
        if (data.length > 0) {
          this.$message.error("选项中不可有填空");
          return;
        }
        if (this.tempQuestionOptionIndex >= 0) {
          // 找到对应的选项的值
          this.data.questionOptions[this.tempQuestionOptionIndex].value =
            content.content;
        }
      } else if (this.ueditorDialogData.title == "填空题答案") {
        // 编辑选项
        if (data.length > 0) {
          this.$message.error("答案中不可有填空");
          return;
        }
        if (this.tempQuestionOptionIndex >= 0) {
          // 找到对应的选项的值
          this.data.questionAnswer[this.tempQuestionOptionIndex].value =
            content.content;
          this.data.questionAnswer[this.tempQuestionOptionIndex].htmlValue =
            content.text;
        }
      } else if (this.ueditorDialogData.title == "简答题答案") {
        if (data.length > 0) {
          this.$message.error("答案中不可有填空");
          return;
        }
        this.data.questionAnswer[0].value = content.content;
        this.data.questionAnswer[0].htmlValue = content.text;
      }
      this.cancelDialog();
    },
    /**
     * 添加选项
     */
    addQuestionOptions() {
      if (this.data.questionOptions.length == 7) {
        this.$message.error("最多只能设置7个可选项");
        return;
      }
      let data = {
        title: this.$numberToLetter(this.data.questionOptions.length + 1),
        value: "",
      };
      this.data.questionOptions.push(JSON.parse(JSON.stringify(data)));
      console.log("添加选项", data);
    },
    /**
     * 移除选项
     */
    removeQuestionOptions(index) {
      this.data.questionOptions.splice(index, 1);
      this.data.questionOptions.forEach((element, index) => {
        element.title = this.$numberToLetter(index + 1);
      });
    },
    /**
     * 提交
     */
    async submit() {
      try {
        // 1.整理属性内容
        let requestData = JSON.parse(JSON.stringify(this.data));
        console.log(requestData);
        // 2.非空判断
        // if (requestData.topicnType == "3" || requestData.topicnType == "4") {
        //   // 判断题/简答题,将答案放置在数组中
        //   requestData.questionAnswer = [{ value: requestData.questionAnswer }];
        // }
        switch (requestData.topicnType) {
          case "0":
            // 单选
            if (requestData.questionAnswer.length > 0) {
              if (requestData.questionAnswer[0].value == "") {
                throw { message: "答案不可为空!" };
              }
              if (!requestData.questionAnswer[0].htmlValue) {
                this.$set(
                  requestData.questionAnswer[0],
                  "htmlValue",
                  requestData.questionAnswer[0].value
                );
              }
            } else {
              throw { message: "答案不可为空!" };
            }
            break;
          case "1":
            // 多选
            if (
              requestData.questionAnswer.length > 0 &&
              requestData.questionAnswer[0].value.length > 0
            ) {
              console.log("多选答案不为空");
              let answer = JSON.parse(
                JSON.stringify(requestData.questionAnswer[0].value)
              );
              console.log(answer);
              requestData.questionAnswer = [];
              answer.forEach((element) => {
                let dd = {
                  value: element,
                  htmlValue: element,
                };
                requestData.questionAnswer.push(dd);
              });
            } else {
              throw { message: "答案不可为空!" };
            }
            break;
          case "2":
            // 填空
            if (requestData.questionAnswer.length > 0) {
              requestData.questionAnswer.forEach((element) => {
                if (element.value == "") {
                  throw { message: "答案不可为空!" };
                }
              });
            }
            break;
          case "3":
            // 判断
            if (requestData.questionAnswer == "") {
              throw { message: "答案不可为空!" };
            }
            requestData.questionAnswer = [
              {
                value: requestData.questionAnswer,
                htmlValue: requestData.questionAnswer,
              },
            ];
            break;
          case "4":
            // 简答
            if (requestData.questionAnswer.length > 0) {
              requestData.questionAnswer.forEach((element) => {
                if (element.value == "") {
                  throw { message: "答案不可为空!" };
                }
              });
            }
            break;

          default:
            break;
        }
        if (requestData.subject == "") {
          throw { message: "科目不可为空!" };
        }
        if (requestData.questionStem == "") {
          throw { message: "题干不可为空!" };
        }
        if (requestData.topicnType == "0" || requestData.topicnType == "1") {
          if (requestData.questionOptions.length == 0) {
            throw { message: "选项不可为空!" };
          }
        }
        // 3.调用新增/编辑接口
        let resultData = await this.$request({
          url: "/questionBank/saveOrUpdateQuestionBank",
          method: "post",
          data: requestData,
        });
        this.$message.success("添加成功!");
        this.$router.back();
      } catch (error) {
        this.$message.error(error.message);
      }
      // 4.返回上一页
    },
    /**
     * 关闭编辑框
     */
    cancelDialog() {
      this.ueditorDialogData.flag = false;
    },
    /**
     * 返回上一页
     */
    goback() {
      this.$confirm(
        "离开页面会丢失当前编辑的内容,是否保存当前编辑的内容?",
        "您即将离开编辑页面",
        {
          confirmButtonText: "保存",
          cancelButtonText: "返回",
          type: "warning",
        }
      )
        .then(async () => {
          // 保存
          await this.submit();
        })
        .catch(() => {
          this.$router.back();
        });
    },
  },
  mounted() {
    this.id = this.$route.query.id;
    this.init();
  },
};
</script>

<style lang="less" scoped>
#admin-question-edit {
  width: 100%;
  height: 100%;
  display: flex;
  padding: 10px 15px;
  box-sizing: border-box;
  > .content {
    width: 100%;
    height: 100%;
    background-color: #fff;
    display: flex;
    flex-direction: column;
    overflow-y: auto;
    > .line {
      width: 100%;
      // min-height: 45px;
      display: flex;
      margin-bottom: 10px;
      padding-right: 30px;
      box-sizing: border-box;
      .title {
        width: 180px;
        line-height: 35px;
        text-align: center;
        display: flex;
        align-items: flex-start;
        justify-content: flex-end;
        font-size: 145x;
        font-weight: bold;
        margin-right: 10px;
      }
      > .value {
        width: 0;
        flex: 1;
        height: auto;
        min-height: 45px;
        display: flex;
        align-items: flex-start;
        justify-content: flex-start;
        /deep/ .el-input__inner {
          height: 35px;
        }
        /deep/ .el-select .el-input .el-select__caret {
          display: flex;
          align-items: center;
        }
        > .tip {
          width: auto;
          height: auto;
          padding: 7px 15px;
          box-sizing: border-box;
          background-color: #bbe0f5;
          color: @baseColor;
          border: 1px solid @baseColor;
          box-sizing: border-box;
          border-radius: 3px;
          font-size: 14px;
          margin: 0 8px;
          display: flex;
          align-items: center;
          > i {
            margin-left: 8px;
            cursor: pointer;
          }
        }
        /deep/ .el-radio-group {
          height: 40px;
          display: flex;
          align-items: center;
        }
        > .tips {
          line-height: 45px;
          text-align: center;
          margin-left: 13px;
          font-size: 13px;
          color: #f00;
        }
      }
      .ueditor {
        border: 1px solid @baseColor;
        cursor: pointer;
        padding: 5px;
        box-sizing: border-box;
      }
      > .bj {
        background-color: #f1f1f1;
        flex-direction: column;

        > .li {
          width: 100%;
          height: 40px;
          display: flex;
          align-items: center;
          margin: 10px 0;
          > .li-va {
            width: 0;
            height: 100%;
            flex: 1;
            display: flex;
            align-items: center;
            justify-content: flex-start;
            padding: 0 10px;
            box-sizing: border-box;
          }
        }
      }
    }
  }

  /deep/ .gapfilling-span {
    /* background-color: antiquewhite; */
    display: inline-block;
    /* text-decoration: underline; */
    border-bottom: 1px solid #444;
    padding: 0 30px;
    margin: 0 5px;
  }
  .el-icon-star-off {
    font-size: 25px;
    color: #eeeeee;
    cursor: pointer;
  }
  .el-icon-star-on {
    color: #ffe710;
    font-size: 25px;
    cursor: pointer;
  }
}
</style>